import React from "react";
/**
 * The Deep View API returns human-readable text with markdown-style markup,
 * e.g. "**Clicks** are matched via `link_name → brand_id`." This renders the
 * `**…**` segments as bold and rewrites backtick spans as quoted text.
 */
export const renderDeepViewText = (text?: string | null): React.ReactNode => {
  if (!text) return null;
  return text.split(/(\*\*[^*]+\*\*|`[^`]+`)/g).map((part, index) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      return <strong key={index}>{part.slice(2, -2)}</strong>;
    }
    if (part.startsWith("`") && part.endsWith("`")) {
      return `"${part.slice(1, -1)}"`;
    }
    return part;
  });
};
